module.exports = {
  "zones": {
    "Asia/Tokyo": ["z", {
      "wallclock": -2587678861000,
      "format": "J%sT",
      "abbrev": "JST",
      "offset": 32400000,
      "posix": -2587712400000,
      "save": 0,
      "rules": "Japan"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 33539000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Japan": [{
      "from": 1948,
      "to": 1951,
      "month": 8,
      "day": [6, 8],
      "time": 1500,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1950,
      "to": 1951,
      "month": 4,
      "day": [6, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1949,
      "to": 1949,
      "month": 3,
      "day": [6, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1948,
      "to": 1948,
      "month": 4,
      "day": [6, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }]
  }
};